const color_map = {
  'bg-gray-600': '#4B5563',
  'bg-blue-600': '#2563EB',
  'bg-amber-600': '#D97706',
  'bg-orange-600': '#ea580c',
  'bg-green-600': '#059669',
  'bg-purple-600': '#7C3AED',
  'bg-red-600': '#dc2626',
  'bg-pink-600': '#db2777',
};

export function get_color_from_class(css_class) {
  return color_map[css_class];
}
